import { useMemo } from "react";

import { useOrganizationsQuery } from "./use-organizations-query";

export function useOrganizationById(organizationId?: string) {
  const query = useOrganizationsQuery({
    enabled: Boolean(organizationId),
  });

  const organization = useMemo(() => {
    if (!organizationId) return null;
    const organizations = query.data?.organizations;
    if (!Array.isArray(organizations)) return null;
    return organizations.find((org) => org.id === organizationId) ?? null;
  }, [organizationId, query.data]);

  return {
    ...query,
    organization,
  };
}
